"use strict";

const SimpleAccordion = require('./lum-simple-accordion.js');
const $ = jQuery;

module.exports = class {
	#$module;
    #$accordionContainers;

    #accordions;
	#data;

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;
        this.#$accordionContainers = $module.find('.accordion-container');

        this.#$accordionContainers.each((i) => {
            this.#accordions.push(new SimpleAccordion($accordionContainers.eq(i), data));
        });

        // this.bind();
	}

    bind() {
    }

    get $module() {
        return this.#$module;
    }

    get $accordionContainers() {
        return this.#$accordionContainers;
    }

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.settings.id;
    }

    get moduleId() {
        return this.data.node;
    }

}